angular.module('picmonic-common').directive('specialOfferBanner', [
  function () {
    return {
      restrict: 'E',
      template:
        '<div ng-hide="UserService.user.user_id || now > 1511506800" class="pls-gradient-lightly-sunburned pls-font-24 pls-font-cabin text-center p-t-1 p-b-1" style="cursor:pointer;position:relative;height: 54px;" ng-click="showRegisterModal()">\n' +
        '    <em class="pls-white" style="position: relative;top: 2px;">Sign up free & get a special offer!</em><a class="pls-btn pls-btn--white pls-grapefruit m-l-2 hidden-xs">Sign Up</a>\n' +
        '</div>',
      replace: true,
      scope: {
        marketSlug: '<',
      },
      controller: [
        '$scope',
        '$modal',
        'MarketOptionsConfig',
        'UserService',
        function ($scope, $modal, MarketOptionsConfig, UserService) {
          $scope.UserService = UserService;
          $scope.now = Math.floor(new Date().getTime() / 1000);
          $scope.showRegisterModal = function () {
            $modal.open({
              templateUrl: '/templates/modals/register-modal.html',
              windowClass: 'registration-cta-modal full-screen-modal',
              backdropClass: 'modal-body-reduced',
              controller: 'RegisterModalController',
              resolve: {
                card: function () {
                  return undefined;
                },
                tab: function () {
                  return 'register';
                },
                redirect: function () {
                  return '/find-picmonic' + ($scope.marketSlug ? '?market=' + $scope.marketSlug : '');
                },
                extraParams: function () {
                  return null;
                },
              },
            });
          };
        },
      ],
    };
  },
]);
